import { useState } from "react";
import { useDispatch } from "react-redux";
import { showNotification } from "../../common/headerSlice";
import api from "../../../utils/axios";
import { triggerRefresh } from "../../../utils/refreshRegistry";

function DeleteScheduleModalBody({ closeModal, extraObject }) {
  const dispatch = useDispatch();
  const schedule = extraObject;
  const [deleting, setDeleting] = useState(false);

  const deleteSchedule = async () => {
    setDeleting(true);
    try {
      await api.delete(`/api/schedules/${schedule.id}`, {
        withCredentials: true,
      });
      dispatch(showNotification({ message: "Schedule row deleted successfully!", status: 1 }));
      closeModal();
      triggerRefresh("schedules");
    } catch (error) {
      console.error("Error deleting schedule row:", error);
      const errorMsg =
        error.response?.data?.message ||
        "Failed to delete schedule row. Please try again.";
      dispatch(showNotification({ message: errorMsg, status: 0 }));
    } finally {
      setDeleting(false);
    }
  };

  return (
    <>
      <p className="text-base">Are you sure you want to delete this schedule row?</p>
      {schedule && (
        <div className="mt-4 text-sm text-gray-600">
          <p><strong>Weekday:</strong> {schedule.weekday}</p>
          <p><strong>Time:</strong> {schedule.time}</p>
          <p><strong>Meeting:</strong> {schedule.meeting}</p>
          <p><strong>Place:</strong> {schedule.place}</p>
        </div>
      )}

      <div className="modal-action">
        <button
          className="btn btn-ghost"
          onClick={() => closeModal()}
          disabled={deleting}
        >
          Cancel
        </button>
        <button
          className="btn btn-error px-6"
          onClick={() => deleteSchedule()}
          disabled={deleting}
        >
          {deleting ? (
            <>
              <span className="loading loading-spinner loading-sm"></span>
              Deleting...
            </>
          ) : (
            "Delete"
          )}
        </button>
      </div>
    </>
  );
}

export default DeleteScheduleModalBody;
